<template>
  <div class="account-right fixed-mp-cls">
    <div class="account-breadcrumb">
      <ul>
        <li>
          <router-link :to="{ name: 'home' }">
            {{ _T('Home') }}
            <img src="/images/svg/global/arrow-right-r.svg" alt="" />
          </router-link>
        </li>
        <li>{{ _T('My Addresses') }}</li>
      </ul>
    </div>
    <div class="account-card">
      <div class="account-body profile-media">
        <div class="account-header">
          <h4>
            <div class="back-cart">
              <router-link
                :to="{ name: 'profile.personal-info' }"
                class="back-loyalty"
              >
                <svg class="rightarrow" fill="none">
                  <use xlink:href="#left-arrow" />
                </svg>
              </router-link>
            </div>
            {{ _T('My Address') }}
          </h4>
          <button
            class="btn-outline-tertiary btn float-right"
            @click="addAddress()"
          >
            {{ _T('Create new Address') }}
          </button>
        </div>
        <div class="address-height">
          <loader v-show="processInProgress(process)" status="DELETING" />
          <div class="media">
            <div class="media-body">
              <div
                class="row"
                v-if="customer_addresses && customer_addresses.length"
              >
                <div
                  class="col-lg-6"
                  v-for="(address, key) in customer_addresses"
                  :key="key"
                >
                  <div class="adress-card">
                    <div class="content">
                      <h4>
                        {{ _T('Delivery Area') }}:
                        {{ ' ' + deliveryAreaName(address.delivery_area_id) }}
                      </h4>
                      <customer-addresses :address="address" />
                      <br />
                    </div>
                    <div class="icon" @click="editAddress(address)">
                      <img src="/images/svg/global/edit.svg" />
                    </div>
                    <div class="icon" @click="deleteAddress(address)">
                      <img src="/images/svg/global/trash.svg" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-else>
                <h5 class="nothing-found">{{ _T('No Address found') }}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <customer-address ref="customerAddress" />
    <confirmation-modal
      :modalId="deleteAddressModalId"
      :confirmationAction="confirmDeleteAddress"
    >
      <template slot="header">
        <h4 class="modal-title mb-0">{{ _T('Delete Address') }}</h4>
      </template>
      <template slot="body">
        <h6>{{ _T('Do you really want to delete address') }}?</h6>
      </template>
    </confirmation-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CustomerAddress from '@/components/Modals/CustomerAddress'
import Loader from '@/components/Elements/Loader'
import CustomerAddresses from '../Util/CustomerAddresses'
import ConfirmationModal from '@/components/Modals/ConfirmationModal'

export default {
  name: 'Address',
  components: {
    CustomerAddress,
    Loader,
    CustomerAddresses,
    ConfirmationModal,
  },
  data() {
    return {
      process: 'delete-address',
      deleteAddressModalId: 'delete-address',
      selectedAddress: '',
    }
  },
  computed: {
    ...mapGetters([
      '_T',
      'deliveryAreaName',
      'customer_addresses',
      'processInProgress',
    ]),
  },
  methods: {
    addAddress() {
      this.$store.dispatch('setAddressToEdit', null)
      this.$bvModal.show('add-address')
    },
    editAddress(address) {
      this.$store.dispatch('setAddressToEdit', address._id)
      this.$store.commit('SET_CUSTOMER_SELECTED_ADDRESS', address)

      const deliveryAreaName = this.deliveryAreaName(address.delivery_area_id)
      this.$refs['customerAddress']['selectedArea'] = deliveryAreaName
      this.$refs['customerAddress']['deliveryArea']['nearest_landmark'] =
        address.nearest_landmark
      this.$refs['customerAddress']['deliveryArea']['street'] = address.street
      this.$refs['customerAddress']['deliveryArea']['building'] =
        address.building
      this.$refs['customerAddress']['deliveryArea']['flat_number'] =
        address.flat_number
      this.$refs['customerAddress']['isEditing'] = true

      this.$bvModal.show('add-address')
    },
    deleteAddress(address) {
      this.selectedAddress = address
      this.$bvModal.show(this.deleteAddressModalId)
    },
    confirmDeleteAddress() {
      let address = this.selectedAddress
      if (!this.processInProgress(this.process)) {
        var old_address = this.getAddressToEdit
        this.$store.dispatch('setAddressToEdit', address._id)
        this.$store.dispatch('startProcess', {
          process: this.process,
          progress: true,
        })
        this.$store.commit('SET_CUSTOMER_SELECTED_ADDRESS', address)
        this.$store
          .dispatch('deleteCustomerAddress')
          .then(() => {
            this.$store.dispatch('setAddressToEdit', old_address)
            this.$store.dispatch('showNotification', {
              text: this._T('Address deleted successfully'),
              status: 'success',
            })
          })
          .finally(() => {
            this.$store.dispatch('stopProcess', this.process)
            this.$bvModal.hide(this.deleteAddressModalId)
            this.$store.dispatch('load_customer', true)
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.body-rtl {
  .account-menu {
    .account-breadcrumb {
      ul {
        padding-left: unset;
        padding-right: 0;
        text-align: right;
      }
    }
  }
  .account-right {
    .account-card {
      .account-body {
        .media {
          .media-body {
            .adress-card {
              .content {
                text-align: right;
              }
              .icon {
                text-align: left !important;
              }
            }
          }
        }
      }
    }
  }
}
.account-right {
  .account-breadcrumb {
    ul {
      li {
        line-height: $px17;
        letter-spacing: 0.005em;
        a {
          font-weight: 600;
        }
        img {
          margin-left: $px12;
          margin-right: $px7;
        }
      }
    }
    .breadcrumb-innerpage {
      li {
        font-weight: 600;
      }
    }
  }
  .coords {
    font-size: 0.6rem;
  }
  .account-card {
    box-shadow: 0px $px4 $px34 rgba($black, 0.07);
    margin: $px18 0 $px30;
    border-radius: $px10;
    .account-body {
      &.profile-media {
        .address-height {
          overflow: hidden;
          max-height: $px500;
          overflow-y: auto;
          &::-webkit-scrollbar {
            display: none;
          }
        }
        .media {
          padding: calc(
              #{$px20} + (34 - 20) * ((100vw - #{$px320}) / (1920 - 320))
            )
            calc(#{$px20} + (45 - 20) * ((100vw - #{$px320}) / (1920 - 320)));
          align-items: center;
          .btn {
            padding: $px8
              calc(#{$px20} + (48 - 20) * ((100vw - #{$px320}) / (1920 - 320)));
          }
          + .media {
            border-top: $px1 solid $light-border;
          }
          .profile-user {
            img {
              width: $px40;
              height: $px40;
              border-radius: 100%;
            }
          }
          .media-body {
            margin-left: $px20;
            .nothing-found {
              font-weight: bold;
            }
            h6 {
              margin-bottom: $px5;
              line-height: $px14;
              letter-spacing: 0.005em;
              color: rgba(var(--color-font-color-source), 0.44);
              font-weight: 500;
            }
            h4 {
              margin-bottom: 0;
              line-height: $px18;
              font-weight: 500;
            }
            .adress-card {
              padding: calc(
                #{$px10} + (20 - 10) * ((100vw - #{$px320}) / (1920 - 320))
              );
              border: $px1 solid $dark-border;
              border-radius: $px4;
              margin-bottom: $px15;
              display: flex;
              align-items: flex-start;
              height: calc(
                #{$px100} + (150 - 100) * ((100vw - #{$px320}) / (1920 - 320))
              );
              overflow: auto;
              overflow-x: hidden;
              &::-webkit-scrollbar {
                width: $px5;
              }
              &::-webkit-scrollbar-track {
                background: $scrollbar-track;
                border-radius: $px6;
              }
              &::-webkit-scrollbar-thumb {
                background: $scrollbar-thumb;
                border-radius: $px4;
              }
              &::-webkit-scrollbar-thumb:hover {
                background: darken($scrollbar-track, 0.2);
              }
              h4 {
                font-weight: 600;
                margin-bottom: $px5;
                font-size: $px16;
                letter-spacing: 0.02em;
                line-height: $px22;
              }
              h5 {
                font-size: $px14;
                margin-bottom: 0;
              }
              .content {
                width: 90%;
              }
              .icon {
                width: 10%;
                text-align: right;
                cursor: pointer;
                img {
                  width: $px20;
                  height: $px20;
                }
              }
            }
          }
        }
      }
    }
  }
  .account-header {
    border-bottom: $px1 solid $light-border;
    padding: $px18 $px30;
    position: relative;
    .back-cart {
      display: none;
    }
    h4 {
      font-weight: 600;
      margin-bottom: 0;
      .mark-cls {
        font-size: $px14;
        line-height: $px22;
        color: $color-primary;
        float: right;
      }
    }
    button {
      display: inline-block;
      position: absolute;
      top: $px9;
      right: $px20;
    }
  }
}
@media (max-width: 1199px) {
  .account-header {
    padding: $px20 $px30;
  }
}
@media (max-width: 991px) {
  .account-header {
    padding: $px18 $px20;
  }
}
@media (max-width: 767px) {
  .account-right {
    &.fixed-mp-cls {
      padding-bottom: $px30;
    }
  }
}
@media (max-width: 575px) {
  .account-breadcrumb {
    display: none;
  }
  .account-header {
    .back-cart {
      display: inline-block !important;
      margin-right: $px3;
      svg {
        width: $px16;
        height: $px16;
        margin-top: $px3;
      }
    }
    h4 {
      img {
        float: right;
      }
    }
    .btn-outline-tertiary {
      margin-top: $px10;
      float: unset !important;
      display: block !important;
      position: relative !important;
      top: 0 !important;
      right: 0 !important;
      padding: $px6 $px10;
      font-size: $px12;
    }
  }
  .account-card {
    margin: 0 !important;
    box-shadow: none !important;
    .address-height {
      max-height: 100% !important;
      .media-body {
        margin-left: 0 !important;
        .adress-card {
          height: auto !important;
        }
      }
    }
  }
}
</style>
